import { atom } from '@reatom/framework'

export const snapPointAnimatingAtom = atom(false, 'snapPointAnimatingAtom')
